import { useEffect } from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { useState } from "react";

// duration tính theo giây
export const useCoutDown = (options) => {
  const [intervalTime] = useState(options.intervalTime ?? 1000);
  const [duration, setDuration] = useState(options.duration * 1000);
  const [refresh, setRefresh] = useState(Math.random());

  const reset = useCallback((newDuration) => {
    setDuration(newDuration * 1000);
    setRefresh(Math.random());
  }, []);

  const readableDuration = useMemo(() => {
    let seconds = Math.floor((duration / 1000) % 60);
    let minutes = Math.floor(duration / (1000 * 60));
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    return `${minutes}:${seconds}`;
  }, [duration]);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setDuration((prev) => {
        const nextValue = prev - intervalTime;
        if (nextValue > 0) return nextValue;
        clearInterval(countdownInterval);
        return 0;
      });
    }, intervalTime);

    return () => {
      clearInterval(countdownInterval);
    };
  }, [intervalTime, refresh]);

  return {
    duration,
    reset,
    readableDuration,
  };
};
